import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-departmemt-modal',
  templateUrl: './departmemt-modal.component.html',
  styleUrls: ['./departmemt-modal.component.scss']
})
export class DepartmemtModalComponent implements OnInit {

  isLoading = true;
  Errors = null;
  titles = null;
  mode = null;
  data = null
  Success = null

  deptForm = new FormGroup({
    name: new FormControl('', Validators.required),
    print_name: new FormControl('', Validators.required),
    status: new FormControl('', Validators.required),
    id: new FormControl(null, Validators.required),
  });


  constructor(private modal: ModalService, private _snackBar: MatSnackBar, public auth: SettingsService) { }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      name,
      print_name,
      status,
      id,
    } = this.deptForm.value;
    this.auth
      .postDept(
        name,
        print_name,
        status,
        id,
      )
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;
          console.log(resSuccess)

          if (this.data.success) {
            this.closeModal()
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });           }
          else {
            this.Errors = "Not successful, please try again"
            console.log("error")
          }
          
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr)
        }
      );
  }
  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {

    this.auth
      .getDept()
      .subscribe(
        (resSuccess) => {

          this.titles = resSuccess
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      ); 
  }
  addNew() {
    this.mode = "add"
  }
  edit(title) {
    this.mode = "edit"
    this.deptForm.patchValue({
      name: title.name,
      print_name: title.print_name ,
      status: title.status ,
      id: title.id,
    });
    console.log(title.id)
  }

  delete(title) {
    this.auth
      .delSet("/api/departments/deleteDept", title.id)
      .subscribe(
        (resSuccess) => {
          this.titles = this.titles.filter(dattum => dattum.id !== title.id)
          this._snackBar.open('Deleted Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        },
        (resErr) => {
          this._snackBar.open('Error try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      );
  }

}
